import { BannerSliderCreate } from '@/modules/home/banner-slider-create';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import HomeBannerSlider from '../home/banner-slider.home';
import { BannerSliderEdit } from '../../components/forms/banner-slider-edit.form';

export default function BannerSlider() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <BannerSliderCreate />;
      case PermissionMode.EDIT:
        return <BannerSliderEdit />;
      default:
        return <HomeBannerSlider />;
    }
  };
  return <>{renderContent()}</>;
}
